/* tslint:disable */
/* eslint-disable */
/**
 * classes-service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const PriceOverrideSort = {
    DecisionDate: 'decision_date',
    Amount: 'amount',
    ProgramSession: 'program_session',
    RequestedDate: 'requested_date',
    StudentName: 'student_name',
    Id: 'id'
} as const;

export type PriceOverrideSort = typeof PriceOverrideSort[keyof typeof PriceOverrideSort];



